import { useEffect, useState } from "preact/hooks";

export const useCancelProgressBar = (props) => {
    const {orderStatus} = props;

    const INACTIVE_STATUS = 1;
    const ACTIVE_STATUS = 2;
    const CHECKED_STATUS = 3;

    // 1: inactive; 2: active; 3: checked
    const [stepInfos, setStepInfos] = useState({
        first: CHECKED_STATUS,
        second: CHECKED_STATUS,
        third: ACTIVE_STATUS,
        fourth: INACTIVE_STATUS,
    });

    const handleStepInfos = () => {
        if (['processing_cancel'].includes(orderStatus)) {
            setStepInfos((prevState) => ({
                ...prevState,
                first: CHECKED_STATUS,
                second: CHECKED_STATUS,
                third: ACTIVE_STATUS,
                fourth: INACTIVE_STATUS,
            }));
        }

        if (['canceled'].includes(orderStatus)) {
            setStepInfos((prevState) => ({
                ...prevState,
                first: CHECKED_STATUS,
                second: CHECKED_STATUS,
                third: CHECKED_STATUS,
                fourth: CHECKED_STATUS,
            }));
        }
    }

    useEffect(() => {
        handleStepInfos();
    }, [orderStatus]);

    return {
        stepInfos
    }
};